<template>
  <div class="product-carousel">
    <ACarousel
      :options="carouselSettings"
      class="swiper"
    >
      <ACarouselSlide
        v-for="(item, imageIndex) in images"
        :key="imageIndex"
        :index="imageIndex"
      >
        <div class="image-container">
          <div class="image">
            <AImage
              :img="item"
              :cover="false"
              contain
              preset="wineproductdetails"
              ratio="3-4"
            />
          </div>
        </div>
      </ACarouselSlide>
    </ACarousel>
  </div>
</template>

<script>
export default {
  name: 'product-image-display',
  props: {
    images: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      carouselSettings: {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
          clickable: true
        }
      }
    }
  },
  computed: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";

//deals with transparent png images for wine bottles
::v-deep  .cool-lightbox .cool-lightbox__slide img {
  background: white;
}

.ls {
  fill: transparent;
  stroke: var(--vc-link-color);
  stroke-width: 7;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}

.product-carousel {
  .custom-arrow {
    width: 2em;
    opacity: 0;
  }

  @include hover-focus {
    .custom-arrow {
      opacity: 1;
    }
  }

  //arrows
 ::v-deep .slick-arrow {
    //opacity: 0;
    transition: opacity 0.3s ease-in-out;
    z-index: 10;
    position: relative;
    cursor: pointer;
    &.slick-next,
    &.slick-prev {
      position: absolute;
      display: block;
      line-height: 0;
      font-size: 0;
      font-size: 1em;
      cursor: pointer;
      top: 50%;
      transform: translateY(-50%);
      padding: 0;
      outline: none;
    }

    &.slick-prev {
      left: 0;
      transform: translateX(0rem);
    }

    &.slick-next {
      right: 0;
      transform: translateX(-2rem);
    }
    &.slick-disabled .icon-container {
      opacity: 0.25;
      cursor: default;
      pointer-events: none;
    }
  }

  //dots
 ::v-deep .swiper-pagination {
    bottom: 0;
    margin-top: var(--carousel-gap);
    position: relative;
    width: calc(100% - var(--carousel-gap));
    text-align: center;
    padding: 0;
    z-index: var(--dots-z-index);

    .swiper-pagination-bullet {
      display: inline-flex;
      justify-content: center;
      list-style: none;
    }

    .swiper-pagination-bullet {
      // all: unset;
      font-size: 0;
      width: 0.7rem;
      height: 0.7rem;
      margin: 0em 0.25em;
      background: var(--vc-border-color);
      border-radius: 100%;
      line-height: 1;
      opacity: 1;
      cursor: pointer;
      transition: 0.3s ease-in-out;
      @include hover-focus {
        opacity: 0.5;
      }
    }
    li.slick-active button {
      opacity: 1;
      background: var(--vc-link-color);
    }
  }
}
// .slick-slide {
//   .image {
//     background: var(--product-image-background);
//     position: absolute;
//     height: 100%;
//     width: 100%;
//     padding: 1.5em;
//     cursor: zoom-in;
//   }
//   .image-container {
//     height: 0;
//     padding-bottom: 100%;
//     padding-bottom: var(--product-image-aspect-ratio, 125%);
//     position: relative;
//     overflow: hidden;
//     z-index: 1;
//   }

//   img {
//     object-fit: var(--product-image-fit, contain);
//     width: 100%;
//     height: 100%;
//     justify-content: center;
//     align-items: center;
//   }
//   .item-inner {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//   }
// }
</style>
